<template>
  <v-list>
    <v-list-item>
      <template #prepend>
        <v-icon :icon="mdiAccountGroupOutline"></v-icon>
      </template>
      <v-list-item-title>契約者マイページ</v-list-item-title>
    </v-list-item>
    <v-divider></v-divider>
    <template v-if="showBillings">
      <v-list-item id="toBillingsList" :to="{ name: 'BillingsList' }">
        <template #prepend>
          <v-icon :icon="mdiFormatListBulleted"></v-icon>
        </template>
        <v-list-item-title>契約</v-list-item-title>
      </v-list-item>
    </template>
    <template v-if="showAccounts">
      <v-list-item id="toAccountsList" :to="{ name: 'AccountsList' }">
        <template #prepend>
          <v-icon :icon="mdiAccountSettings"></v-icon>
        </template>
        <v-list-item-title>ログインアカウント</v-list-item-title>
      </v-list-item>
    </template>
    <template v-if="showContacts">
      <v-list-item id="toEmergencyContactsList" :to="{ name: 'EmergencyContactsList' }">
        <template #prepend>
          <v-icon :icon="mdiPhoneInTalk"></v-icon>
        </template>
        <v-list-item-title>連絡先</v-list-item-title>
      </v-list-item>
    </template>
    <template v-if="showinvoices">
      <v-list-item id="toInvoicesList" :to="{ name: 'InvoicesList' }">
        <template #prepend>
          <v-icon :icon="mdiReceiptText"></v-icon>
        </template>
        <v-list-item-title>請求書</v-list-item-title>
      </v-list-item>
    </template>
    <template v-if="showManuals">
      <v-list-item id="toManualsList" :to="{ name: 'ManualsList' }">
        <template #prepend>
          <v-icon :icon="mdiHelpCircleOutline"></v-icon>
        </template>
        <v-list-item-title>マニュアル</v-list-item-title>
      </v-list-item>
    </template>
    <!-- v-list-item id="toBillingContactsList" :to="{ name: 'BillingContactsList' }">
      <v-list-item-icon>
        <v-icon>mdi-file-document</v-icon>
      </v-list-item-icon>
      <v-list-item-title>請求書送付先</v-list-item-title>
    </v-list-item -->
  </v-list>
</template>

<script>
import Api from '@/constants/api';
import UserRole from '@/constants/userrole';
import { mdiAccountGroupOutline, mdiFormatListBulleted, mdiAccountSettings, mdiPhoneInTalk, mdiReceiptText, mdiHelpCircleOutline } from '@mdi/js';

export default {
  props: {
    billinggroupId: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    showBillings: false,
    showAccounts: false,
    showContacts: false,
    showManuals: false,
    showinvoices: false,
    loginUser: {
      billinggroupId: '',
      roleId: -1,
    },
    mdiAccountGroupOutline,
    mdiFormatListBulleted,
    mdiAccountSettings,
    mdiPhoneInTalk,
    mdiReceiptText,
    mdiHelpCircleOutline,
  }),
  watch: {
    billinggroupId: async function () {
      await this.createMenu();
    },
  },
  created: async function () {
    await this.createMenu();
  },
  methods: {
    createMenu: async function () {
      const accessToken = this.$cookies.get('access_token');
      console.log('accessToken=' + accessToken);

      let sessionResponse = await this.axios.get(Api.PATH_SESSION);
      console.log(sessionResponse);
      if (sessionResponse.data.status == Api.STATUS_SUCCESS) {
        this.loginUser.billinggroupId = sessionResponse.data.session.billinggroup_id;
        this.loginUser.roleId = sessionResponse.data.session.role_id;
      } else {
        this.$cookies.remove('access_token');
        this.$router.push({ name: 'Login' });
        return;
      }
      const allowedViewAllPages = [UserRole.ADMIN, UserRole.MANAGER, UserRole.USER];
      const allowedViewInvoices = [UserRole.BILLINGUSER];
      const allowedViewManuals = [UserRole.ADMIN, UserRole.MANAGER, UserRole.USER, UserRole.BILLINGUSER];
      this.showBillings = allowedViewAllPages.includes(this.loginUser.roleId);
      this.showAccounts = allowedViewAllPages.includes(this.loginUser.roleId);
      this.showContacts = allowedViewAllPages.includes(this.loginUser.roleId);
      this.showManuals = allowedViewManuals.includes(this.loginUser.roleId);
      this.showinvoices = allowedViewAllPages.concat(allowedViewInvoices).includes(this.loginUser.roleId);
    },
  },
};
</script>
